import { Displaying } from "@bonusx-global/bx-design-system";
import Box from "@mui/material/Box";

export const emptyComponentId = "empty-component";

export function EmptyComponent(): JSX.Element {
  return <Box data-testid={emptyComponentId} display={Displaying.none} />;
}
